export enum ShopSelectMapControls {
  ZOOM,
  GEOLOCATION,
}
